module.exports = __webpack_public_path__ + "img/BiaoZhun.b49ec929.png";